import React, { useState } from "react";
import "./WeatherUnitConversion.css";

export default function WeatherUnitConversion(props) {
  const [unit, setUnit] = useState("celsius");

  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  function showCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  if (unit === "celsius") {
    return (
      <div className="WeatherUnitConversion">
        <div className="temperature-container d-flex justify-content-end">
          <img src={props.iconUrl} alt={props.iconAlt} />
          <div className="WeatherTemperature">
            <span className="temperature">{Math.round(props.celsius)}</span>
            <span className="unit">
              °C |{" "}
              <a href="/" onClick={showFahrenheit}>
                °F
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  } else {
    let fahrenheit = (props.celsius * 9) / 5 + 32;
    return (
      <div className="WeatherUnitConversion">
        <div className="temperature-container d-flex justify-content-end">
          <img src={props.iconUrl} alt={props.iconAlt} />
          <div className="WeatherTemperature">
            <span className="temperature">{Math.round(fahrenheit)}</span>
            <span className="unit">
              <a href="/" onClick={showCelsius}>
                °C
              </a>{" "}
              | °F
            </span>
          </div>
        </div>
      </div>
    );
  }
}
